const mimeTypes = ["image/svg+xml"];

export function validate(file) {
  const ext = file.name.split(".").pop();
  if (file.type === "" && ext === "svg") {
    return true;
  }
  if (mimeTypes.indexOf(file.type) >= 0) {
    return true;
  }
  return false;
}

export function getUploadMimeType() {
  return "image/svg+xml";
}